import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { createContext, type ReactNode } from 'react';
import { cn } from '@/libs/utils';
import { SortRadioButton } from './SortRadioButton';
interface SortRadioGroupContextType<T extends string> {
  sortBy?: T;
  sortType?: 'asc' | 'desc';
  onSortChange?: (data: {
    sortBy: T;
    sortType?: 'asc' | 'desc';
  } | {
    sortBy: undefined;
    sortType: undefined;
  }) => void;
}
export const SortRadioGroupContext = createContext<SortRadioGroupContextType<string>>({
  sortBy: undefined,
  sortType: undefined,
  onSortChange: undefined
});
interface SortRadioGroupProps<T extends string> {
  sortBy?: T;
  sortType?: 'asc' | 'desc';
  onSortChange?: (data: {
    sortBy: T;
    sortType?: 'asc' | 'desc';
  } | {
    sortBy: undefined;
    sortType: undefined;
  }) => void;
  children: ReactNode;
  showAll?: boolean;
  className?: string;
}
export const SortRadioGroup = t0 => {
  const $ = _c(25);
  const {
    sortBy,
    sortType,
    onSortChange,
    children,
    showAll: t1,
    className
  } = t0;
  const showAll = t1 === undefined ? false : t1;
  const t = useTranslations("Shared.filters");
  let t2;
  if ($[0] !== onSortChange) {
    t2 = data => onSortChange?.(data as {
      sortBy: T;
      sortType: 'asc' | 'desc';
    } | {
      sortBy: undefined;
      sortType: undefined;
    });
    $[0] = onSortChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== sortBy || $[3] !== sortType || $[4] !== t2) {
    t3 = {
      sortBy,
      sortType,
      onSortChange: t2
    };
    $[2] = sortBy;
    $[3] = sortType;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== className) {
    t4 = cn("flex items-center gap-1.5 lg:gap-2 h-8 lg:h-10", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("sortBy");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-[14px] lg:text-[16px] leading-[1.4] text-[#A0A3E2] lg:px-1 shrink-0">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== showAll || $[13] !== t) {
    t7 = showAll && <SortRadioButton sortBy="all" disabledSortTypeChange={true}>{t("all")}</SortRadioButton>;
    $[12] = showAll;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== children || $[16] !== t7) {
    t8 = <div className="flex gap-2">{t7}{children}</div>;
    $[15] = children;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t4 || $[19] !== t6 || $[20] !== t8) {
    t9 = <div className={t4}>{t6}{t8}</div>;
    $[18] = t4;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t9) {
    t10 = <SortRadioGroupContext.Provider value={t3}>{t9}</SortRadioGroupContext.Provider>;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};